import faker from 'faker';
import { useRef } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import roundArrowRightAlt from '@iconify/icons-ic/round-arrow-right-alt';
import instagramFilled from '@iconify/icons-ant-design/instagram-filled';
// material
import { useTheme } from '@material-ui/core/styles';
import { Box, Card, Button, Container, Typography, IconButton, Grid } from '@material-ui/core';
//
import { varFadeIn, varFadeInUp, MotionInView, varFadeInDown } from '../../animate';
import { CarouselControlsArrowsBasic2 } from '../../carousel';
import { FaqsForm } from '../faqs';
import HomeContactForm from '../faqs/HomeContactForm';
import { Helmet } from 'react-helmet';

// ----------------------------------------------------------------------

export default function HomePageContactForm() {


  return (
    <Box sx={{ mt: 3,pl: { xs: 3, sm: 3, md: 6 }, pr: { xs: 3, sm: 3, md: 6 },overflow:'hidden',}}>
      <Helmet>
        <title>Leader in custom software development, IT services, and solutions.</title>
        <meta name="description" content="skyniche Technologies offers custom software development, IT services, and comprehensive solutions to meet your business needs and drive success." />
        <meta name="keywords" content="skyniche Technologies" />
      </Helmet>
      <MotionInView variants={varFadeInUp}>
        <Grid sx={{ mt:2,mb:4 }}>
            <HomeContactForm/>
        </Grid>
      </MotionInView>

    </Box>
  );
}